import { useEffect, useMemo, useState } from 'react';
import { Permission } from '../index';
import { RootStateOrAny, useSelector, useDispatch } from 'react-redux';
import { transformPermissions } from '../transformPermissions';
import { getGlobalCountries } from '../../../redux/actions/regionsActions';

export function useInvariantGeographies(permissions: Permission[] = []) {
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const { globalCountries } = useSelector((state: RootStateOrAny) => state.RegionsReducer);

  useEffect(() => {
    if (!permissions.length) return;

    if (globalCountries.length) {
      setLoading(false)
      return;
    }

    if (loading) return;

    dispatch(getGlobalCountries());
    setLoading(true);
  }, [permissions, globalCountries, loading, dispatch]);

  const invariantGeographies = useMemo(() => transformPermissions({ permissions, globalCountries }), [permissions, globalCountries]);

  return invariantGeographies;
}